import { render, staticRenderFns } from "./campaignsTable.vue?vue&type=template&id=e42555d0&scoped=true"
import script from "./campaignsTable.vue?vue&type=script&lang=js"
export * from "./campaignsTable.vue?vue&type=script&lang=js"
import style0 from "./campaignsTable.vue?vue&type=style&index=0&id=e42555d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42555d0",
  null
  
)

export default component.exports